import script from "./LightButtonMappingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LightButtonMappingPage.vue?vue&type=script&setup=true&lang=js"

import "./LightButtonMappingPage.vue?vue&type=style&index=0&id=e4dc9304&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4dc9304"]])

export default __exports__